// Edit a SIP account / extension: number + display name + secret + status.
// Secret left blank = unchanged (PATCH /sip-accounts/:id only patches present
// fields).
// Shared by SubscriberDetail's SIP Accounts tab and the ExtensionsList kebab.

import { useState } from 'react';

export default function EditExtensionModal({ account, onSave, onCancel, isPending, error }) {
  const [username, setUsername] = useState(account.username || '');
  const [displayName, setDisplayName] = useState(account.displayName ?? account.display_name ?? '');
  const [secret, setSecret] = useState('');
  const [status, setStatus] = useState(account.status || 'active');

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <h3 className="text-lg font-bold text-gray-900">Edit Extension</h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const body = {};
            if (username.trim() && username.trim() !== account.username) body.username = username.trim();
            // Cleared field sends '' → stored as NULL, so the phone goes back to
            // showing the number rather than an empty line.
            const dn = displayName.trim();
            if (dn !== (account.displayName ?? account.display_name ?? '')) body.display_name = dn;
            if (secret.trim()) body.secret = secret.trim();
            if (status !== account.status) body.status = status;
            onSave(body);
          }}
          className="mt-4 space-y-3"
        >
          <div>
            <label className="block text-sm font-medium text-gray-700">Extension number</label>
            <input
              type="text" value={username} onChange={(e) => setUsername(e.target.value)} required
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-1.5 font-mono text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Display name</label>
            <input
              type="text" value={displayName} onChange={(e) => setDisplayName(e.target.value)}
              placeholder={account.username || 'e.g. Front Desk'}
              maxLength={64}
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
            <p className="mt-1 text-xs text-gray-500">
              Shown on the phone&rsquo;s screen and to other extensions on this PBX. Blank shows the
              extension number. Takes effect on the next provisioning push.
            </p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">SIP secret</label>
            <input
              type="text" value={secret} onChange={(e) => setSecret(e.target.value)}
              placeholder="leave blank to keep current"
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Status</label>
            <select
              value={status} onChange={(e) => setStatus(e.target.value)}
              className="mt-1 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option value="active">active</option>
              <option value="inactive">inactive</option>
            </select>
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button" onClick={onCancel} disabled={isPending}
              className="rounded-md border border-gray-300 px-4 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit" disabled={isPending}
              className="rounded-md bg-blue-600 px-4 py-1.5 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
            >
              {isPending ? 'Saving…' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
